import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { modules } from '../data/modules';

export default function Sidebar({ theme, onToggleTheme }) {
  // All module groups start expanded
  const [openGroups, setOpenGroups] = useState(() =>
    modules.reduce((acc, m) => ({ ...acc, [m.id]: true }), {})
  );

  const toggleGroup = (id) => {
    setOpenGroups(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <aside className="sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <NavLink to="/crm/leads" className="logo-badge">
          <img src={`${process.env.PUBLIC_URL}/image/lobees-logo.png`} alt="Lobees" className="logo-image" />
        </NavLink>
        <div className="logo-sub">API Documentation v2.0</div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {modules.map((mod, i) => (
          <div key={mod.id} className="module-group">
            {i > 0 && <div className="sidebar-divider" />}

            <div
              className="module-group-header"
              onClick={() => toggleGroup(mod.id)}
              role="button"
              aria-expanded={openGroups[mod.id]}
            >
              <span className="module-group-title">{mod.name}</span>
              <span className={`module-group-arrow ${openGroups[mod.id] ? 'open' : ''}`}>
                ▶
              </span>
            </div>

            {openGroups[mod.id] && (
              <div className="submodule-list">
                {mod.submodules.map(sub => (
                  <NavLink
                    key={sub.id}
                    to={sub.path || `/${mod.id}/${sub.id}`}
                    className={({ isActive }) =>
                      `submodule-link${isActive ? ' active' : ''}`
                    }
                  >
                    <span className="submodule-icon">{sub.icon}</span>
                    <span className="submodule-name">{sub.name}</span>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* Footer: theme toggle */}
      <div className="sidebar-footer">
        <button className="theme-toggle" onClick={onToggleTheme}>
          <span className="theme-toggle-icon">
            {theme === 'dark' ? '☀️' : '🌙'}
          </span>
          <span>{theme === 'dark' ? 'Light mode' : 'Dark mode'}</span>
        </button>
      </div>
    </aside>
  );
}
